
export default {
  props: {
    title: {
      default: '',
    },
  },
}
